import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const BasicInfoSection = ({ formData, errors, onChange }) => {
  const ageOptions = Array.from({ length: 63 }, (_, i) => ({
    value: (i + 18)?.toString(),
    label: `${i + 18} years`
  }));

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 shadow-warm">
      <h3 className="text-lg md:text-xl font-heading font-semibold mb-4 md:mb-6">
        Basic Information
      </h3>
      <div className="space-y-4 md:space-y-5">
        <Input
          label="Display Name"
          type="text"
          name="displayName"
          placeholder="Choose a display name (not your real name)"
          description="This is how others will see you. Keep it anonymous."
          value={formData?.displayName}
          onChange={onChange}
          error={errors?.displayName}
          required
          maxLength={30}
        />

        <Select
          label="Age"
          name="age"
          placeholder="Select your age"
          description="Your age must be 18 or above"
          options={ageOptions}
          value={formData?.age}
          onChange={(value) => onChange({ target: { name: 'age', value } })}
          error={errors?.age}
          required
          searchable
        />

        <div className="p-4 bg-muted rounded-lg">
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
              <span className="text-lg">🔒</span>
            </div>
            <div>
              <h4 className="text-sm font-caption font-semibold mb-1">Privacy First</h4>
              <p className="text-xs text-muted-foreground">
                Your real identity remains completely anonymous. Use a display name that doesn't reveal your actual identity.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicInfoSection;